
import Cookies from 'js-cookie';

export const GuestGuard = async () => {

    const token_header =  Cookies.get('accessToken') || '';


    return !token_header;
};